import {Modifier, EditorState} from 'draft-js';

const addSuggestion = ({editorState, start, end, trigger, text, suggestion}) => {
	const contentState = editorState.getCurrentContent();
	const contentStateWithEntity = contentState.createEntity('MENTION', 'IMMUTABLE', {
		mention: {
			personId: suggestion.personId,
			name: suggestion.name,
			avatar: suggestion.avatar,
		},
	});
	const currentSelectionState = editorState.getSelection();
	const mentionTextSelection = currentSelectionState.merge({
		anchorOffset: start,
		focusOffset: end,
	});

	let insertingContent = Modifier.replaceText(editorState.getCurrentContent(), mentionTextSelection, text, null, contentStateWithEntity.getLastCreatedEntityKey());

	const blockKey = mentionTextSelection.getAnchorKey();
	const blockSize = editorState.getCurrentContent().getBlockForKey(blockKey).getLength();
	if (blockSize === end) {
		insertingContent = Modifier.insertText(insertingContent, insertingContent.getSelectionAfter(), ' ');
	}

	const newEditorState = EditorState.push(editorState, insertingContent, 'insert-mention');

	return EditorState.forceSelection(newEditorState, insertingContent.getSelectionAfter());
};

export default addSuggestion;
